import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { BASE_PROJECT_PATH, generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}${BASE_PROJECT_PATH}/settings/dashboard/report-url`;

type UpdateReportUrlResponse = null;
type UpdateReportUrlDTO = {
  newUrl: string;
  projectId: number;
};

export const updateReportUrl = ({
  newUrl,
  projectId,
}: UpdateReportUrlDTO): Promise<UpdateReportUrlResponse> => {
  const URL = generateRoutePath(url, { projectId });

  return axios.put(URL, { url: newUrl });
};

type UseUpdateReportUrlOptions = {
  config?: MutationConfig<typeof updateReportUrl>;
};

export const useUpdateReportUrl = ({ config }: UseUpdateReportUrlOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: () => {},
    mutationFn: (props) => updateReportUrl(props),
  });
};
